import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {UsanaObject} from "../../usana-object";
import {LoggerService} from "../../common/logger.service";
import {productImageFilter} from "../../cart/image/filter/product-image-filter";
import {IProductImage} from "../product-models";

@Component({
    selector: 'product-thumb-carousel',
    templateUrl: './product-thumb-carousel.component.html',
    styleUrls: ['./product-thumb-carousel.component.scss'],
    standalone: false
})
export class ProductThumbCarouselComponent extends UsanaObject implements OnInit, OnChanges {

    @Input() images: IProductImage[];
    @Input() displaySize: string;
    @Input() thumbSize: string;
    @Input() maxImages: number;
    imageType: string = "productImage";
    selectedImageIndex: number = 0;
    filteredImages: IProductImage[];

    constructor(
        loggerService: LoggerService,
    ) {
        super(loggerService);
    }

    ngOnInit() {
        if(!this.displaySize) {
            this.displaySize = "LG";
        }
        if(!this.thumbSize) {
            this.thumbSize = "TH";
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.images.currentValue) {
            this.filteredImages = productImageFilter()(this.images, this.imageType, this.thumbSize, undefined, this.maxImages);
            this.selectedImageIndex = 0;
        }
    }

    changeSelectedIndex(idx: number): void {
        if (idx >= this.images.length || idx < 0) {
            idx = 0;
        }
        this.selectedImageIndex = idx;
    }
}
